import { ScreenState } from "./screen";

class GroupedComponent{
  /**
   * 
   * @param {number} x 
   * @param {number} y 
   * @param {number} width 
   * @param {number} height 
   * @param {ScreenState} screenState 
   */
  constructor(x, y, width, height, screenState){
    this.width = width;
    this.height = height;
    this.screenState = screenState;
    
    const scalingWidth = (width/this.screenState.devlopmentScreenWidth*this.screenState.width) / width;
    const scalingHeight = (height/this.screenState.devlopmentScreenHeight*this.screenState.height) / height;
    this.scaling = Math.max(scalingWidth, scalingHeight);
    this.renderWidth = width*this.scaling;
    this.renderHeight = height*this.scaling;


    this.x = screenState.offsetX + (x+width/2)/screenState.devlopmentScreenWidth*screenState.width - this.renderWidth/2;
    this.y = screenState.offsetY + (y+height/2)/screenState.devlopmentScreenHeight*screenState.height - this.renderHeight/2;

    this.center_x = this.x + this.renderWidth/2
    this.center_y = this.y + this.renderHeight/2
  }

  calculateCenter(x, y, width, height){
    return [x + width/2, y + height/2]
  }

  rectResizeV2(x, y, width, height, customTransitionProgress){
    const transitionProgressFinal = customTransitionProgress != undefined ? customTransitionProgress : this.screenState.transitionProgress;
    const [finalWidth, finalHeight] = [width*transitionProgressFinal*this.scaling, height*transitionProgressFinal*this.scaling]
    return [this.x + (x+width/2)*this.scaling - finalWidth/2, this.y + (y+height/2)*this.scaling - finalHeight/2, finalWidth, finalHeight]
  }

  resizeXY(x, y, customTransitionProgress){
    const transitionProgressFinal = customTransitionProgress != undefined ? customTransitionProgress : this.screenState.transitionProgress;
    const [widthDiff, heightDiff] = [(this.center_x - x*this.scaling)*transitionProgressFinal, (this.center_y - y*this.scaling)*transitionProgressFinal];
    return [this.x + this.center_x - widthDiff, this.y + this.center_y - heightDiff];
  }

  /**
   * Resize X and Y coordinates with transitioning from a predefined bounding center coordinates 
   * (I have no idea what i'm saying but i know exactly what this function does XD.
   * Hope to find a better way to describe this.)
   * @param {number} x 
   * @param {number} y 
   * @param {number} centerX 
   * @param {number} centreY 
   * @param {number | undefined} customTransitionProgress 
   * @returns Resized Coordinates
   */
  resizeXY_V2(x, y, centerX, centreY, customTransitionProgress){
    const transitionProgressFinal = customTransitionProgress != undefined ? customTransitionProgress : this.screenState.transitionProgress;
    const [widthDiff, heightDiff] = [(centerX - (this.x + x*this.scaling))*transitionProgressFinal, (centreY - (this.y + y*this.scaling))*transitionProgressFinal];
    return [centerX - widthDiff, centreY - heightDiff];
  }

  resizeLine(x, y, x2, y2, customTransitionProgress){
    const transitionProgressFinal = customTransitionProgress != undefined ? customTransitionProgress : this.screenState.transitionProgress;
    const [center_x, center_y] = [(x + x2)/2, (y + y2)/2];
    const [widthDiff, heightDiff] = [(x2-x)/2*transitionProgressFinal, (y2-y)/2*transitionProgressFinal]
    return [...this.resizeXY(center_x-widthDiff, center_y-heightDiff, transitionProgressFinal), ...this.resizeXY(center_x+widthDiff, center_y+heightDiff, transitionProgressFinal)];
  }
}

export default GroupedComponent;